"use strict";Object.defineProperty(exports, "__esModule", {value: true});
const additionalFieldFakeId = "##additional##"

exports. default = {
  props: {
    fields: Array,
    additionalFields: Boolean
    // event: addField
  },
  created() {
    this.additionalFieldFakeId = additionalFieldFakeId
  },
  methods: {
    handleChange(ev) {
      const additionalFields = this.$props.additionalFields 

      let id = ev.target.value
      ev.target.value = ""

      if (additionalFields && id === additionalFieldFakeId) { id = prompt("请输入 id：") || '' }
      if (!id) return

      this.$emit('addField', id)
    },
    onInputBoxBlur() {
      const value = this.$refs.inputBox.value
      if (value) this.$emit('addField', value)
      this.$refs.inputBox.value = ''
    }
  }
};

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.fields.length && _vm.additionalFields
    ? _c("div", { staticClass: "ds-basicForm-addProperty" }, [
        _c("input", {
          ref: "inputBox",
          attrs: { type: "text", placeholder: "输入新属性名..." },
          on: {
            blur: _vm.onInputBoxBlur,
            keypress: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInputBoxBlur.apply(null, arguments)
            }
          }
        })
      ])
    : _vm.fields.length
    ? _c("div", { staticClass: "ds-basicForm-addProperty" }, [
        _c(
          "select",
          { attrs: { value: "" }, on: { change: _vm.handleChange } },
          [
            _c(
              "option",
              { staticStyle: { display: "none" }, attrs: { value: "" } },
              [_vm._v("添加属性...")]
            ),
            _vm._v(" "),
            _vm._l(_vm.fields, function(field) {
              return _c(
                "option",
                { key: field.id, domProps: { value: field.id } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(field.id) +
                      "\n      " +
                      _vm._s(field.title ? " (" + field.title + ")" : "") +
                      "\n    "
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm.additionalFields
              ? _c(
                  "option",
                  {
                    key: "additional",
                    domProps: { value: _vm.additionalFieldFakeId }
                  },
                  [_vm._v("\n      (自行输入key)\n    ")]
                )
              : _vm._e()
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
